// src/shared/utils/globalScripts.js
import React from "react";
import * as Sentry from "@sentry/react";
import Hotjar from "@hotjar/browser";

export function initSentry() {
  Sentry.init({
    dsn: "https://f9bb68fde5cb0daa92edf8e6842b3603@o255514.ingest.us.sentry.io/4509326600241152",
    sendDefaultPii: true,
  });
}

export function injectHotjar() {
  const siteId = 6369144;
  const hotjarVersion = 6;
  Hotjar.init(siteId, hotjarVersion);
}

export function injectGoogleAnalytics() {
  const googleAnalytics = document.createElement("script");
  googleAnalytics.async = true;
  googleAnalytics.src = "https://www.googletagmanager.com/gtag/js?id=G-KYKEZ87E5M";
  document.head.appendChild(googleAnalytics);

  const googleAnalyticsConfig = document.createElement("script");
  googleAnalyticsConfig.innerHTML = `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', 'G-KYKEZ87E5M');
  `;
  document.head.appendChild(googleAnalyticsConfig);
}

export const LiveChatScript = () => {
  React.useEffect(() => {
    const initESW = (gslbBaseURL) => {
      // Optional: Set language if needed
      // embedded_svc.menu.settings.language = 'en';
      window.embedded_svc.menu.init(
        "https://freewayukinsuranceservicesltd.my.salesforce.com",
        "https://d.la11-core1.sfdc-5pakla.salesforceliveagent.com/chat",
        gslbBaseURL,
        "00D4K000004gm6a",
        "Driver_Insurance_Enhanced_Menu"
      );
    };

    const loadLiveChatScript = () => {
      if (!window.embedded_svc || !window.embedded_svc.menu) {
        const script = document.createElement("script");
        script.setAttribute(
          "src",
          "https://freewayukinsuranceservicesltd.my.salesforce.com/embeddedservice/menu/fab.min.js"
        );
        script.onload = () => {
          initESW(null);
        };
        document.body.appendChild(script);
      } else {
        initESW("https://service.force.com");
      }
    };

    loadLiveChatScript();

    // Update WhatsApp button after a slight delay
    const timeoutId = setTimeout(() => {
      const whatsappButton = document.querySelector(".cta-link-whatsapp");
      if (whatsappButton) {
        whatsappButton.href = "https://wa.me/447802416568";
        whatsappButton.target = "_blank";
      }
    }, 2000);

    return () => {
      clearTimeout(timeoutId);
      const script = document.querySelector(
        'script[src="https://freewayukinsuranceservicesltd.my.salesforce.com/embeddedservice/menu/fab.min.js"]'
      );
      if (script) {
        document.body.removeChild(script);
      }
    };
  }, []);

  return null;
};
